import { relativeUrls } from '@/constants/urls';
import { includesComponent } from './layoutManagerHelper';
import { findTabByUrl } from './layoutManagerTabs';

const findTabAndClose = (props, { category, code, url }) => {
  const onClose = findTabByUrl(url).close.dispatcher(props);
  if (onClose) {
    onClose({ category, code });
  }
};

export const closeMultiplePanels = ({ config: { content } }, props) => (
  content.forEach(({ componentState }) => findTabAndClose(props, componentState))
);

const closePanel = (component, props) => {
  const { parent, config } = component;
  const { activeItemIndex } = parent.config;
  const { url } = config.componentState;
  const index = parent.getItemsByType('component').findIndex((item) => includesComponent(item, relativeUrls(url)));

  findTabAndClose(props, config.componentState);
  component.remove();
  if (index <= activeItemIndex && activeItemIndex > 0) {
    parent.config.activeItemIndex -= 1;
  }
};

export default closePanel;
